export enum SeturLoyaltyEarnType {
  FIX_AMOUNT = 'FixAmount',
  PERCENTAGE = 'Percentage',
}
